import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb9c6dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-100 d-flex justify-content-end",
  style: {"position":"absolute","top":"10px","right":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, "X")
], -1))
const _hoisted_2 = { class: "mb-12 d-flex justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "text-center",
  style: {"color":"#9203DD","font-size":"24px","font-weight":"bold"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "bi bi-check-circle-fill text-success fs-2" }, null, -1))
const _hoisted_6 = { style: {"font-weight":"bold","text-align":"center"} }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "d-flex justify-content-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/hc/lux_1.png",
    alt: "image",
    style: {"width":"110%"}
  })
], -1))
const _hoisted_10 = { style: {"font-weight":"bold","font-size":"16px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Rank ")
const _hoisted_12 = { style: {"color":"#9203DD"} }
const _hoisted_13 = {
  class: "p-2",
  style: {"background":"#9203DD","border-radius":"5px","width":"90%","text-align":"center","font-weight":"bold"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "card mb-6 mb-xl-9 pt-0 pb-0"
}
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6 d-flex justify-content-start" }
const _hoisted_21 = { class: "col-md-6 d-flex justify-content-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Flags:", -1))
const _hoisted_23 = { class: "card-title mt-5" }
const _hoisted_24 = { class: "progress col-md-12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "d-flex justify-content-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "row d-flex justify-content-around"
}
const _hoisted_29 = { class: "card mb-6 col-md-5 mb-xl-9 pt-0 pb-0" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = { class: "flex-grow-1" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-9 d-flex justify-content-start" }
const _hoisted_35 = { class: "col-md-3 d-flex justify-content-end" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Flags:", -1))
const _hoisted_37 = { class: "card-title mt-5" }
const _hoisted_38 = { class: "progress col-md-12" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "d-flex justify-content-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_42 = { class: "card mb-6 col-md-5 mb-xl-9 pt-0 pb-0" }
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = { class: "card-title" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-12 d-flex justify-content-start" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf-fill fs-2" }, null, -1))
const _hoisted_48 = { class: "overflow-auto pb-5" }
const _hoisted_49 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded p-5" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/upload.svg"
}
const _hoisted_52 = {
  key: 1,
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/pdf.svg"
}
const _hoisted_53 = {
  key: 2,
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/file.png"
}
const _hoisted_54 = { class: "ms-1 fw-bold" }
const _hoisted_55 = { class: "d-flex align-items-center" }
const _hoisted_56 = ["href"]
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "text-gray-400" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/video.svg"
}, null, -1))
const _hoisted_60 = { class: "ms-1 fw-bold" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "d-flex flex-aligns-center pe-10 pe-lg-20" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/pdf.svg"
}, null, -1))
const _hoisted_65 = { class: "ms-1 fw-bold" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"not-allowed"},
  class: "fs-6 text-hover-primary fw-bolder"
}, "Write-UP", -1))
const _hoisted_67 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AchivementModal = _resolveComponent("AchivementModal")!
  const _component_machine_video_modal = _resolveComponent("machine_video_modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_AchivementModal, { ref: "achivementModal" }, {
        header: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.machine.photo_path,
                class: "avatar-img img-fluid floating",
                style: {"width":"15%"},
                alt: "image"
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.achivement.machine.title`)) + " ", 1),
              _hoisted_5
            ])
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.achivement.machine.message_1`, { user: _ctx.user.nick || 'No nick' })), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.achivement.machine.message_2`, { machine: _ctx.machine.name })), 1),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, " #" + _toDisplayString(_ctx.userStats.ranking), 1)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.moment.duration(_ctx.userStats.time_spent, 'seconds').format([_ctx.moment.duration(1, "minute"),
              _ctx.moment.duration(1,
                "day")], "M[M] w[S] d[d] hh[h] mm[m] ss[s]", { trim: "all" })), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shareOnLinkedin(_ctx.machine.id, _ctx.user.id))),
                type: "button",
                class: "btn btn-custom-achievement mt-12"
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.share_on_linkedin`)), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", null, [
      (_ctx.machine.type == 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.your_progress_on_this_machine_is`)) + ": ", 1),
                      _createTextVNode("  " + _toDisplayString(_ctx.percentage) + "% ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createTextVNode("  " + _toDisplayString(parseFloat(((_ctx.percentage / 100) * _ctx.machine.total_flags).toString()).toFixed(0)) + "/" + _toDisplayString(_ctx.machine.total_flags), 1)
                    ])
                  ]),
                  _createElementVNode("h6", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", {
                        class: "progress-value",
                        style: _normalizeStyle('width: ' + _ctx.percentage + '%')
                      }, null, 4)
                    ]),
                    _hoisted_25
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.percentage == 100)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.explode && _ctx.explode(...args))),
                          type: "button",
                          class: "btn btn-custom-achievement"
                        }, [
                          _hoisted_27,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.share_on_linkedin`)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_machine_video_modal, { ref: "videModal" }, null, 512),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.your_progress_on_this_machine_is`)) + ": ", 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.percentage) + "% ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createTextVNode("  " + _toDisplayString(parseFloat(((_ctx.percentage / 100) * _ctx.machine.total_flags).toString()).toFixed(0)) + "/" + _toDisplayString(_ctx.machine.total_flags), 1)
                      ])
                    ]),
                    _createElementVNode("h6", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", {
                          class: "progress-value",
                          style: _normalizeStyle('width: ' + _ctx.percentage + '%')
                        }, null, 4)
                      ]),
                      _hoisted_39
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.percentage == 100)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.explode && _ctx.explode(...args))),
                            type: "button",
                            class: "btn btn-custom-achievement"
                          }, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.share_on_linkedin`)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.attachments`)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    (_ctx.attachments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "d-flex flex-aligns-center pe-10 pe-lg-20 my-4",
                              key: attachment
                            }, [
                              (attachment.type != 'video')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (attachment.type == 'link')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                                      : (['doc', 'machine'].includes(attachment.type) && attachment.name.includes('.pdf'))
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_52))
                                        : (_openBlock(), _createElementBlock("img", _hoisted_53)),
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("a", {
                                          href: attachment.url,
                                          target: "_blank",
                                          class: "fs-6 text-hover-primary fw-bolder"
                                        }, _toDisplayString(attachment.name), 9, _hoisted_56),
                                        (['doc', 'machine'].includes(attachment.type) && attachment.name.includes('.pdf'))
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: `/media/flags/${_ctx.currentLanguage == 'pt' ? 'brazil' : 'united-states'}.svg`,
                                              alt: "",
                                              class: "ms-2 w-25px flag"
                                            }, null, 8, _hoisted_57))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_58, _toDisplayString(attachment.filename), 1)
                                    ])
                                  ], 64))
                                : (attachment.type == 'video')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_59,
                                      _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("div", {
                                          class: "fs-6 text-hover-primary fw-bolder cursor-pointer",
                                          style: {"color":"#3699FF"},
                                          onClick: ($event: any) => (_ctx.openVideoModal(attachment.url, attachment.metadata.lesson_url, attachment.title))
                                        }, _toDisplayString(attachment.name), 9, _hoisted_61)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _hoisted_64,
                            _createElementVNode("div", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.available_only_for_members`)), 1)
                            ])
                          ])
                        ]))
                  ])
                ])
              ])
            ])
          ]))
    ])
  ], 64))
}